module.exports = {"420113001":"纱帽街道","420113002":"邓南街道","420113003":"东荆街道","420113004":"湘口街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/420113.json
// module id = 1557
// module chunks = 0